<template>
    <layout-user containerClass="bg-white">
        <form autocomplete="off" @submit.prevent="login" method="post" data-vv-scope="form">
            <div class="row">
                <div class="col-sm-12 mt-2 mt-sm-0 mb-4">
                    <h1 class="title text-center text-sm-left">{{ this.pageTitle }}<span class="d-sm-none"><br />novamente!</span></h1>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <MaterialInput
                        autocomplete="new-email"
                        type="text"
                        class="city-form-group city-bg form-xl"
                        id="input-email"
                        name="email"
                        v-model.trim="form.body.email"
                        v-validate="'required|email'"
                        :inputClasses="['form-control-xl', {'is-invalid': fnHasError('email') }]"
                        :error="fnFirstError('email')">
                        Email
                    </MaterialInput>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <MaterialInput
                        autocomplete="new-password"
                        type="password"
                        class="city-form-group city-bg form-xl"
                        id="input-password"
                        name="password"
                        v-model.trim="form.body.password"
                        v-validate="{'required': true, 'min': getMinPasswordLength()}"
                        :inputClasses="['form-control-xl', {'is-invalid': fnHasError('password') }]"
                        :error="fnFirstError('password')">
                        Password
                    </MaterialInput>
                </div>
            </div>
            <div class="row" v-if="errorMsg">
                <div class="col-12">
                    <div class="alert alert-info" role="alert" v-html="errorMsg">
                    </div>
                </div>
            </div>
            <div class="row pb-4">
                <div class="d-none d-sm-flex col-sm-5 col-lg-6 text-left text-sm-center">
                    <!-- Stay Signed In -->
                    <div class="form-check city-form-check pl-2 pl-sm-0">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            id="loginFormStaySignedIn"
                            v-model="form.staySignedIn">
                        <label
                            class="form-check-label"
                            for="loginFormStaySignedIn">
                            <span class="font-small-sm-only text-nowrap">Manter sessão</span>
                        </label>
                    </div>
                </div>
                <div class="col-12 col-sm-7 col-lg-6 text-center text-sm-right mb-sm-3">
                    <!-- Forgot password -->
                    <router-link :to="{ name: `${pageID}.resetpassword` }" class="">
                        <span class="font-small-sm-only">Esqueceu-se da password?</span>
                    </router-link>
                </div>
            </div>
            <div class="row justify-content-center no-gutters pt-sm-3">
                <div class="col-12 col-sm-12 text-center mx-auto">
                    <button
                        class="btn btn-main btn-rounded btn-lg btn-responsive btn-block z-depth-0 mt-4 mb-3 my-lg-5 mx-0"
                        type="submit"
                        :disabled="isDisabled">
                        Entrar
                    </button>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-12 text-center d-none d-sm-none">
                    <router-link :to="{ name: `${pageID}.resetpassword` }" class="">
                        <span class="font-small-sm-only">Esqueceu-se da password?</span>
                    </router-link>
                </div>
            </div> -->
            <div class="row" v-if="$router.resolve({name: `${pageID}.register`}).resolved.matched.length > 0">
                <div class="col-12 col-sm-12 text-center mx-auto mb-3 my-sm-5">
                    <!-- Register -->
                    <span class="font-small-sm-only d-none d-sm-inline">Ainda não tem uma conta?</span>
                        <router-link :to="{ name: `${pageID}.register` }" class="pl-sm-3">
                            <span class="font-small-sm-only d-none d-sm-inline">Criar conta</span>
                            <button
                                class="btn btn-outline-main btn-rounded btn-lg btn-responsive btn-block z-depth-0 d-block d-sm-none"
                                type="submit">
                                Criar conta
                            </button>
                        </router-link>
                </div>
            </div>
        </form>
    </layout-user>
</template>
<script>
import mixin from '../../mixin'
import LayoutUser from '../../layouts/User.vue'
import { isArray } from '@config/utils';

export default {
    mixins: [mixin],
    components: {
        'layout-user': LayoutUser,
    },
    data() {
        return {
            pageID: 'portal',
            pageTitle: 'Login',
            prevRoute: null,
            form: {
                body: {
                    email: null,
                    password: null,
                },
                rememberMe: true,
                // Setting it to false will clear the token after the browser closes.
                // When setting the value to false the token will still remain on browser refresh.
                staySignedIn: !!this.$root.$env.DEBUG,
                fetchUser: true,
            },
            errorMsg: null,
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },
    beforeCreate() {
        if (this.$route.query.verify) {
            try{
                let url = atob(decodeURIComponent(this.$route.query.verify));
                this.$http.get(decodeURIComponent(url))
                    .then(res => {
                        this.showMessage(res.data.data);
                    })
                    .catch(error => {
                        this.showHttpError(error);
                    })
                    .finally(() => {
                        this.$router.push({ name: `${this.pageID}.login` })
                    })
            } catch(err) {
                console.error(err.message);
            }
        }
    },
    methods: {
        reset() {
            this.errorMsg = null;
            Object.assign(this.$data.form, this.$options.data().form);
        },
        login() {
            this.clearMessages();
            this.errorMsg = null;

            this.$validator.validateAll('form')
            .then(result => {
                if (!result) {
                    this.showError('Por favor corrija os erros no formulário', this.pageTitle);
                    return;
                }

                let authRoutes = [
                    `${this.module}.profile`,
                    `${this.module}.resetpassword`,
                    `${this.module}.resendverificationemail`,
                    `${this.module}.login`,
                    `${this.module}.logout`,
                    `${this.module}.register`,
                    `${this.module}.resetpasswordform`,
                    `${this.module}.resetpasswordform`,
                    `${this.module}.resetpasswordform`,
                ];
                let redirect = { path: '/' };
                if (this.prevRoute != null && !authRoutes.includes(this.prevRoute.name)) {
                    redirect = { path: this.prevRoute.fullPath };
                } else {
                    redirect = { name: this.initialPagePlatform };
                }

                this.$auth.login({
                    data: this.form.body,
                    redirect: null,
                    fetchUser: this.form.fetchUser,
                    staySignedIn: this.form.staySignedIn, // When setting the value to false the token will still remain on browser refresh.
                }).then(() => {
                    if (this.form.rememberMe) {
                        this.$auth.remember(JSON.stringify({
                            name: this.$auth.user().name
                        }));
                    }else {
                        this.$auth.unremember();
                    }
                    this.$root.setFlagLoadSettings(true);
                    this.$router.push(redirect);
                }).catch(error => {
                    if(error.response && error.response.data){
                        error = error.response.data;
                    }

                    let verifyMessage = error.error && error.error.verify ? error.error.verify : null;
                    if(verifyMessage){
                        this.errorMsg = this.$sanitize(isArray(verifyMessage) ? verifyMessage.join(", ") : verifyMessage);
                    }else{
                        this.showHttpError(error);
                    }
                })
            });
        }
    }
}
</script>

<style scoped lang="scss">
    .reset-password {
    	padding-left: 0px;
    }
</style>